import { getTagTree } from '../../../services/api.js'

import { treeToMap, searchByType, getTagIndicators } from '../../../utils/tree.js'

export default {
  state: {
    tree: null,
    tagsMap: null,
    indicatorsMap: null,
    metaMap: {},
    types: ['group', 'firstLevel', 'secondLevel'],
    preselection: null,
  },
  getters: {
    tag: state => tagId => {
      return state.tagsMap[tagId]
    },
    tagType: state => tagType => {
      return searchByType(state.tree, tagType)
    },
    tagIndicators: state => tagId => {
      if (state.tagsMap[tagId]) {
        const tag = state.tagsMap[tagId]
        const inds = getTagIndicators(tag)
        if (tag.tagType === 'firstLevel')
          inds.forEach(ind => {
            state.indicatorsMap[ind.indicatorId].tagIcon = tag.imageURL
            if (/DF_MAINSH$/i.test(ind.cube.cubeMetaId)) {
              if (!/(share|ratio|contributions)/i.test(ind.label.en)) {
                ind.label.en = ind.label.en + ', shares'
              }
            }
          })
        return inds
      }
      return []
    },
    treeIndicator: state => indId => {
      return state.indicatorsMap[indId]
    },
  },
  mutations: {
    tagData(state, tree) {
      state.tree = tree
      state.tagsMap = treeToMap(tree)
      state.indicatorsMap = searchByType(tree, 'secondLevel').reduce((acum, tag) => {
        if (tag.dataSources) {
          tag.dataSources.forEach(cube => {
            cube.indicators.forEach(ind => {
              if (acum[ind.indicatorId] === void 0) {
                acum[ind.indicatorId] = { cube: cube, tagIcon: tag.parent.imageURL, ...ind }
              } else {
                let group = tag.parent
                while (group.parent) group = group.parent
                if (group.tagName.en === 'Databases')
                  acum[ind.indicatorId].tagIcon = tag.parent.imageURL
              }
              state.metaMap[ind.metaId] = ind.indicatorId
            })
          })
        }
        return acum
      }, {})
    },
    preselection(state, value) {
      state.preselection = value
    },
  },
  actions: {
    getTagTree(context, params) {
      if (params.layout === 'embedded') {
        context.commit('tagData', [])
        return Promise.resolve()
      }
      return getTagTree(params).then(data => {
        context.commit('tagData', data)
      })
    },
  },
}
